import React from 'react';
import {TreeSelect as AntTreeSelect} from 'antd';
import './TreeSelect.less';
export default class TreeSelect extends AntTreeSelect {
    render(){
        return <AntTreeSelect {...this.props} className={`hms-tree-select ${this.props.className || ''}`}>{this.props.children}</AntTreeSelect>
    }
}